export const ORDER_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  RETURNED: 'RETURNED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED'
};

export const ORDER_STATUS_TEXT = {
  [ORDER_STATUS.PENDING]: 'Yeni Sipariş',
  [ORDER_STATUS.PROCESSING]: 'Hazırlanıyor',
  [ORDER_STATUS.SHIPPED]: 'Kargoya Verildi',
  [ORDER_STATUS.DELIVERED]: 'Teslim Edildi',
  [ORDER_STATUS.RETURNED]: 'İade Edildi',
  [ORDER_STATUS.CANCELLED]: 'İptal Edildi',
  [ORDER_STATUS.REFUNDED]: 'İade Edildi (Ödeme)'
};

export const ORDER_STATUS_STYLES = {
  [ORDER_STATUS.PENDING]: {
    bg: '#ffeaa71a',
    text: '#fdcb6e',
    icon: 'shopping-cart'
  },
  [ORDER_STATUS.PROCESSING]: {
    bg: '#74b9ff1a',
    text: '#0984e3',
    icon: 'box-open'
  },
  [ORDER_STATUS.SHIPPED]: {
    bg: '#81ecec1a',
    text: '#00cec9',
    icon: 'truck'
  },
  [ORDER_STATUS.DELIVERED]: {
    bg: '#00b8941a',
    text: '#00b894',
    icon: 'check-circle'
  },
  [ORDER_STATUS.RETURNED]: {
    bg: '#fab1a01a',
    text: '#e17055',
    icon: 'undo'
  },
  [ORDER_STATUS.CANCELLED]: {
    bg: '#ff76751a',
    text: '#ff7675',
    icon: 'times-circle'
  },
  [ORDER_STATUS.REFUNDED]: {
    bg: '#dfe6e91a',
    text: '#636e72',
    icon: 'money-bill-wave'
  }
};

export const SHIPMENT_STATUS = {
  PENDING: 'PENDING',           // Kargo firmasına iletilecek
  LABEL_CREATED: 'LABEL_CREATED',     // Barkod oluşturuldu
  PICKED_UP: 'PICKED_UP',         // Kargo teslim alındı
  IN_TRANSIT: 'IN_TRANSIT',        // Taşınıyor
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',  // Dağıtıma çıktı
  DELIVERED: 'DELIVERED',         // Teslim edildi
  FAILED: 'FAILED',            // Teslimat başarısız
  RETURNED: 'RETURNED',          // İade edildi
  CANCELLED: 'CANCELLED'          // İptal edildi
};

export const SHIPMENT_STATUS_TEXT = {
  [SHIPMENT_STATUS.PENDING]: 'Kargo Bekliyor',
  [SHIPMENT_STATUS.LABEL_CREATED]: 'Barkod Hazır',
  [SHIPMENT_STATUS.PICKED_UP]: 'Kargoya Verildi',
  [SHIPMENT_STATUS.IN_TRANSIT]: 'Yolda',
  [SHIPMENT_STATUS.OUT_FOR_DELIVERY]: 'Dağıtımda',
  [SHIPMENT_STATUS.DELIVERED]: 'Teslim Edildi',
  [SHIPMENT_STATUS.FAILED]: 'Teslim Edilemedi',
  [SHIPMENT_STATUS.RETURNED]: 'İade Edildi',
  [SHIPMENT_STATUS.CANCELLED]: 'İptal Edildi'
};

/** Açıklamalar: Kullanıcı durum yanındaki (?) ikonuna tıkladığında gösterilir. Aras Kargo Statü/Durum açıklamalarına dayalı, tüm kargo firmaları için geçerli metinler. */
export const SHIPMENT_STATUS_DESCRIPTION = {
  [SHIPMENT_STATUS.PENDING]: 'Kargo kaydı oluşturuldu; henüz kargo firmasına iletilmedi.',
  [SHIPMENT_STATUS.LABEL_CREATED]: 'Kargo etiketi oluşturuldu; paket henüz kargoya teslim edilmedi.',
  [SHIPMENT_STATUS.PICKED_UP]: 'Paket kargo firması tarafından teslim alındı.',
  [SHIPMENT_STATUS.IN_TRANSIT]: 'Gönderiniz kargo ağında taşınıyor.',
  [SHIPMENT_STATUS.OUT_FOR_DELIVERY]: 'Kargo doğru varış şubesine ulaştı ve teslimata çıkarıldı. Herhangi bir problem olmadan dağıtıma verildi.',
  [SHIPMENT_STATUS.DELIVERED]: 'Kargo herhangi bir problem olmadan teslim edildi.',
  [SHIPMENT_STATUS.FAILED]: 'Kargo teslim edilemedi.',
  [SHIPMENT_STATUS.RETURNED]: 'Kargo teslim edilemedi ve çıkış noktasına iade edildi.',
  [SHIPMENT_STATUS.CANCELLED]: 'Gönderi iptal edildi.'
};

export const SHIPMENT_STATUS_STYLES = {
  [SHIPMENT_STATUS.PENDING]: {
    bg: '#ffeaa71a',
    text: '#fdcb6e',
    icon: 'clock'
  },
  [SHIPMENT_STATUS.LABEL_CREATED]: {
    bg: '#74b9ff1a',
    text: '#0984e3',
    icon: 'tag'
  },
  [SHIPMENT_STATUS.PICKED_UP]: {
    bg: '#81ecec1a',
    text: '#00cec9',
    icon: 'box'
  },
  [SHIPMENT_STATUS.IN_TRANSIT]: {
    bg: '#a8e6cf1a',
    text: '#3d84a8',
    icon: 'truck'
  },
  [SHIPMENT_STATUS.OUT_FOR_DELIVERY]: {
    bg: '#dcedc11a',
    text: '#689f38',
    icon: 'truck-loading'
  },
  [SHIPMENT_STATUS.DELIVERED]: {
    bg: '#d1fae5',
    text: '#059669',
    icon: 'check-circle'
  },
  [SHIPMENT_STATUS.FAILED]: {
    bg: '#fee2e2',
    text: '#dc2626',
    icon: 'times-circle'
  },
  [SHIPMENT_STATUS.RETURNED]: {
    bg: '#fef3c7',
    text: '#b45309',
    icon: 'undo'
  },
  [SHIPMENT_STATUS.CANCELLED]: {
    bg: '#ff76751a',
    text: '#ff7675',
    icon: 'ban'
  }
};

export const SHIPMENT_STATUS_ICONS = {
  [SHIPMENT_STATUS.PENDING]: 'clock',
  [SHIPMENT_STATUS.LABEL_CREATED]: 'tag',
  [SHIPMENT_STATUS.PICKED_UP]: 'box',
  [SHIPMENT_STATUS.IN_TRANSIT]: 'truck',
  [SHIPMENT_STATUS.OUT_FOR_DELIVERY]: 'truck-loading',
  [SHIPMENT_STATUS.DELIVERED]: 'check-circle',
  [SHIPMENT_STATUS.FAILED]: 'times-circle',
  [SHIPMENT_STATUS.RETURNED]: 'undo',
  [SHIPMENT_STATUS.CANCELLED]: 'ban'
};

// ─── Timeline Configuration ─────────────────────────────────────

/** Happy-path sipariş akışı (normal ilerleme sırası) */
export const ORDER_TIMELINE_FLOW = [
  ORDER_STATUS.PENDING,
  ORDER_STATUS.PROCESSING,
  ORDER_STATUS.SHIPPED,
  ORDER_STATUS.DELIVERED
];

/** Akışı sonlandıran (terminal) statüler */
export const ORDER_TERMINAL_STATUSES = [
  ORDER_STATUS.CANCELLED,
  ORDER_STATUS.RETURNED,
  ORDER_STATUS.REFUNDED
];

/**
 * Her adım için timestamp resolver.
 * order objesi alır, ilgili adımın gerçekleşme tarihini döner (veya null).
 */
export const ORDER_TIMELINE_TIMESTAMP_MAP = {
  [ORDER_STATUS.PENDING]: (order) => order.createdAt,
  [ORDER_STATUS.PROCESSING]: (order) => {
    // Shipment oluşturulması ≈ PROCESSING'e geçiş
    if (order.shipment?.createdAt) return order.shipment.createdAt;
    return null;
  },
  [ORDER_STATUS.SHIPPED]: (order) => {
    // trackingHistory'den PICKED_UP veya IN_TRANSIT zamanı
    const history = order.shipment?.trackingHistory;
    if (Array.isArray(history)) {
      const picked = history.find(h => h.status === 'PICKED_UP' || h.status === 'IN_TRANSIT');
      if (picked?.timestamp) return picked.timestamp;
    }
    return order.shipment?.createdAt || null;
  },
  [ORDER_STATUS.DELIVERED]: (order) => {
    return order.actualDeliveryDate || order.shipment?.deliveryDate || null;
  },
  [ORDER_STATUS.CANCELLED]: (order) => {
    return order.metadata?.stockRestoredAt || order.updatedAt;
  },
  [ORDER_STATUS.RETURNED]: (order) => {
    return order.metadata?.returnedAt || order.updatedAt;
  },
  [ORDER_STATUS.REFUNDED]: (order) => {
    return order.metadata?.refundedAt || order.updatedAt;
  }
};

/**
 * Kargo timeline'ında gösterilecek adımlar (sıralı).
 * Ana timeline'ın SHIPPED adımı altında mini-timeline olarak kullanılır.
 */
export const SHIPMENT_TIMELINE_FLOW = [
  SHIPMENT_STATUS.LABEL_CREATED,
  SHIPMENT_STATUS.PICKED_UP,
  SHIPMENT_STATUS.IN_TRANSIT,
  SHIPMENT_STATUS.OUT_FOR_DELIVERY,
  SHIPMENT_STATUS.DELIVERED
];